// extracted by mini-css-extract-plugin
export default {"post":"styles_post__GbSHv","inner":"styles_inner__SNTbf","image":"styles_image__bCn35","brief":"styles_brief__AnuSP"};